import React from 'react';
import EvaluationEventEducator from './EvaluationEventEducator';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'evaluation-event-educator';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <EvaluationEventEducator
        key={`${type}-${index}`}
        evaluation={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
